/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./menu-drop.vue?vue&type=template&id=37bd9825&"
import script from "./menu-drop.vue?vue&type=script&lang=js&"
export * from "./menu-drop.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./menu-drop.vue?vue&type=style&index=0&id=37bd9825&prod&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports